console.log('custom.js loaded');

if (window.alternateHeaderHover) {
	let $body = document.body;
	let fullMenu = document.querySelector('.full-menu');
	let topLevelMenuItems = fullMenu.querySelectorAll('.thb-full-menu > li');
	let topLevelSecondaryItems = document.querySelectorAll('.thb-secondary-area .thb-secondary-area-item');
	let desktopLogo = document.querySelector('#header .logolink');

	if (desktopLogo) {
		desktopLogo.addEventListener('mouseenter', (e)=> {
			$body.classList.add('alternate-header-hover');
		});

		desktopLogo.addEventListener('mouseleave', (e)=> {
			$body.classList.remove('alternate-header-hover');
		});
	}

	if (topLevelMenuItems.length > 0) {
		topLevelMenuItems.forEach((topLevelMenuItem, index) => {
			topLevelMenuItem.addEventListener('mouseenter', (e)=> {
				$body.classList.add('alternate-header-hover');
			});

			topLevelMenuItem.addEventListener('mouseleave', (e)=> {
				$body.classList.remove('alternate-header-hover');
			});
		});
	}

	if (topLevelSecondaryItems.length > 0) {
		topLevelSecondaryItems.forEach((topLevelSecondaryItem, index) => {
			topLevelSecondaryItem.addEventListener('mouseenter', (e)=> {
				$body.classList.add('alternate-header-hover');
			});

			topLevelSecondaryItem.addEventListener('mouseleave', (e)=> {
				$body.classList.remove('alternate-header-hover');
			});
		});
	}
}

if ("register" === window.page_template || "account" === window.page_template) {
	var f = {
		getSchoolList: function () {
			var $schoolList = $("[data-school-list]");
			var prefix = "";
			if ($schoolList.length) {
				$schoolList.empty();
				if ($schoolList.data("my-school") !== undefined) {
					prefix = "student-";
				}
				$.get("//docs.google.com/spreadsheets/d/e/2PACX-1vTy2IZsn2P0MvHWCMu1QaPQZvq24ehJYviq07cqqsv55Hen4mBlHOPa_9KVo_sB6ht1_H8M8HS3bHvV/pub?output=csv", function (data) {
					var parsedData = f.parseCSV(data);
					$.each(parsedData, function (index, row) {
						if (index === 0) return true;
						var schoolCode = row[0] || "";
						var schoolName = schoolCode.replace("school_", "").split(/(?=[A-Z])/).join(" ");
						$schoolList.append("<option value='" + prefix + schoolCode + "'>" + schoolName + "</option>");
					});
					$schoolList.html($schoolList.find("option").sort(function (a, b) {
						return $(a).text() > $(b).text() ? 1 : -1;
					}));
					$schoolList.prepend("<option value='' selected='selected'>Select a School</option>");
					if ($schoolList.data("my-school") !== undefined) {
						$schoolList.val($schoolList.data("my-school"));
					}
				});
			}
		},
		parseCSV: function (t) {
			for (var e = [], i = !1, n = 0, a = 0, r = 0; r < t.length; r++) {
				var s = t[r],
					o = t[r + 1];
				e[n] = e[n] || [], e[n][a] = e[n][a] || "", '"' == s && i && '"' == o ? (e[n][a] += s, ++r) : '"' != s ? "," != s || i ? "\r" != s || "\n" != o || i ? "\n" == s && !i || "\r" == s && !i ? (++n, a = 0) : e[n][a] += s : (++n, a = 0, ++r) : ++a : i = !i
			}
			return e
		}
	};

	f.getSchoolList();
}


